
import api from '../../request/api'
import {  } from '../../constant/storage'

export default {
  namespaced: true,
  state: () => ({
    //
    userinfo:'',
  }),
  mutations: {
    setUserInfo(state, userinfo){
      //
      state.userinfo = userinfo
    }
  },
  actions:{
    // loginByMobile(context, products){
    //   api.login(data).then(res => {

    //   }).catch(err => {

    //   })
    // }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js